import { render, staticRenderFns } from "./DevicesStatisticsByCategory.vue?vue&type=template&id=1b16362c"
import script from "./DevicesStatisticsByCategory.vue?vue&type=script&lang=js"
export * from "./DevicesStatisticsByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports